/**
 * 
 * let e = new EventBus
 * e.on('submit',(e)=>{})
 * e.off('submit')
 */

export interface IEvent<T>{
	type : string;
	data? : T;
	[key : string] : unknown
}


export type IHandler<T> = (e : IEvent<T>)  => any

export default class EventBus {

	private key = 0
	private handlers : {[key :string] : Array<{handler : IHandler<any>,once? : boolean,key : number}> } = {}



	on(type : string, handler : IHandler<any>,options? : {once? : boolean}){
		if(!type){
			throw new TypeError("type is null")
		}
		let key = ++this.key
		this.handlers[type] = this.handlers[type] || []
		this.handlers[type].push({handler,key,once : options?.once})
		return ((_type,_key)=>{  
			return ()=>this.off(_type,_key) 
		})(type,key)
	}

	once(type : string, handler : IHandler<any>){
		return this.on(type,handler,{once : true})
	}

	private off(type : string, key : number){
		if(type && this.handlers[type]){
			this.handlers[type] = this.handlers[type].filter((item)=> item.key !== key)
		}
	}

	trigger(type : string, data? : any,meta? : object,options? : {returnAsData : boolean}){
		if(type && this.handlers[type]){
			this.handlers[type].forEach((item)=>{
				let result : any
				if(typeof item.handler === 'function'){
					result = item.handler({type,data,...meta})
					if(options?.returnAsData){
						data = result
					}
				}
			})
			this.handlers[type] = this.handlers[type].filter((item)=> !item.once)
		}
	}
}